document.addEventListener('click', function (event) {

  /*
   * モーダルを開く
   */
  const openButton = event.target.closest('.modal-open a');

  if (openButton) {
    event.preventDefault();

    const targetId = openButton.getAttribute('href');

    if (!targetId) {
      return;
    }

    const modal = document.querySelector(targetId);

    if (!modal) {
      return;
    }

    modal.classList.add('is-open');
    document.body.classList.add('modal-is-open');

    return;
  }


  /*
   * ×ボタンで閉じる
   */
  const closeButton = event.target.closest('.modal-close');

  if (closeButton) {
    event.preventDefault();

    const modal = closeButton.closest('.modal');

    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    document.body.classList.remove('modal-is-open');

    return;
  }


  /*
   * 背景クリックで閉じる
   */
  const overlay = event.target.closest('.modal .overlay');

  if (overlay) {
    event.preventDefault();

    const modal = overlay.closest('.modal');

    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    document.body.classList.remove('modal-is-open');
  }

});


/*
 * ESCキーで閉じる
 */
document.addEventListener('keydown', function (event) {

  if (event.key !== 'Escape') {
    return;
  }

  const modal = document.querySelector('.modal.is-open');

  if (!modal) {
    return;
  }

  modal.classList.remove('is-open');
  document.body.classList.remove('modal-is-open');

});